import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowRunSourceTranscriptionLaunchFailedAction = {
	type: 'WORKFLOW_RUN_SOURCE_TRANSCRIPTION_LAUNCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowRunSourceTranscriptionLaunchFailedAction => ({
	type: 'WORKFLOW_RUN_SOURCE_TRANSCRIPTION_LAUNCH_FAILED',
	payload,
});
